import { fetchDataSamples } from 'js/actions';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';

type UseDataSamplesAdapter = {
  fetchDataSamples(nexsetID: number): void;
};

const wrappedFetchDataSamples = (dispatch: any) => {
  return (nexsetID: number): Promise<any> => dispatch(fetchDataSamples(nexsetID));
};

export function useDataSamplesAdapter(): UseDataSamplesAdapter {
  const dispatch = useDispatch<any>();
  return useMemo(
    () => ({
      fetchDataSamples: wrappedFetchDataSamples(dispatch),
    }),
    [],
  );
}
